import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { publicRouteGuard } from '../guards/publicRouteLoaderGuard';

const Login = lazy(() => import('@/pages/public/LoginPage'));

/**
 * Configuración de rutas públicas de la aplicación
 * Rutas accesibles sin autenticación, protegidas con publicRouteGuard
 * que redirige a home si el usuario ya está autenticado
 *
 * Rutas incluidas:
 * - /login (index): Página de inicio de sesión
 *
 * @constant {RouteObject[]} publicRoutes - Array de configuración de rutas públicas
 */
export const publicRoutes: RouteObject[] = [
  {
    index: true,
    element: <Login />,
    loader: publicRouteGuard,
  },
];
